export const initCampaign = () => ({
    assignedUser: null,
    budgetValue: null,
    budgetCurrency: null,
    type: null,
    dateFrom: null,
    dateTo: null,
    name: {},
    description: {},
    status: true,
    langCode: null,
    campaignId: null,
})
